import { render, staticRenderFns } from "./SurveyModalShell.vue?vue&type=template&id=1fae4b8d"
import script from "./SurveyModalShell.vue?vue&type=script&lang=ts"
export * from "./SurveyModalShell.vue?vue&type=script&lang=ts"
import style0 from "./SurveyModalShell.vue?vue&type=style&index=0&id=1fae4b8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports